<template>
    <div>
        <rkm-table
            :items="dados || []"
            :fields="fields.tables.tipo"
            :filter="filter"
            sort-by="nomeFantasia"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="data.form.anos"
                            show-default-option
                            default-option-text="Selecione o ano"
                            text-field="cotaAno"
                            v-model="model.cotaAno"
                            @change="handleAnoCota()"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="data.form.meses"
                            show-default-option
                            default-option-text="Selecione o mês"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.cotaMes"
                            @change="handleAnoCota()"
                        />
                    </rkm-col>
                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter && !model.cotaMes && !model.cotaAno"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { formats, repository } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-imagem/tipoCota'

export default {
    components: { Modal },
    computed: {
        fields() {
            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Prestador', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'cotaValor', label: 'Valor', sortable: true },
                        { key: 'valorUtilizado', label: 'Utilizado (valor)', sortable: true },
                        { key: 'valorSaldo', label: 'Saldo (valor)', sortable: true },
                        { key: 'cotaUnidade', label: 'Quantidade', sortable: true },
                        { key: 'quantidadeUtilizada', label: 'Utilizada (quantidade)', sortable: true },
                        { key: 'quantidadeSaldo', label: 'Saldo (quantidade)', sortable: true },
                        { key: 'ano', label: 'Ano', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
        dados() {
            const ano = this.model.cotaAno
            const mes = this.model.cotaMes

            if (this.data.model.cotas) {

                let filterItems = this.data.model.cotas.map(unidade => {

                    if (ano != null && mes != null) {

                        let cotaQuantidadeUtilizada = 0;
                        let cotaValorUtilizado = 0;
                        let cotaSaldoValor = 0;
                        let cotaValor = 0;
                        let cotaUnidade = 0;

                        if(unidade.valorUtilizado){

                            cotaValorUtilizado = unidade.valorUtilizado
                            cotaValorUtilizado = parseFloat(cotaValorUtilizado.toString().replace(".", "").replace(",", "."));
                        }     
                        
                        const cotaSolicitanteFiltrado = unidade.cotaSolicitante.filter(field =>
                            field.periodo.start.substr(6, 4) == ano && field.periodo.start.substr(3, 2) == mes
                        );

                        cotaValor = cotaSolicitanteFiltrado.reduce((sum, element) => sum + this.formatSumMoney(element.cotaValor), 0);
                        cotaUnidade = cotaSolicitanteFiltrado.reduce((sum, element) =>
                            element.cotaUnidade ? sum + Number(element.cotaUnidade) : sum,
                            0
                        );

                        cotaSolicitanteFiltrado.forEach(field => {

                            const anoCota = field.periodo.start.substr(6, 4);
                            const mesCota = field.periodo.start.substr(3, 2);

                            if (anoCota == ano && mesCota == mes) {

                                if (field.cotaTipoId === this.enums.tipoCota.VALOR) {

                                    cotaSaldoValor = cotaValorUtilizado ? (cotaValor - cotaValorUtilizado) : cotaValor;
                                    this.verificaCotaValor = true;
                                } else if (field.cotaTipoId === this.enums.tipoCota.QUANTIDADE) {

                                    cotaQuantidadeUtilizada += 1;
                                    this.verificaCotaQuantidade = true;
                                } 
                            }
                        });


                        const result = {
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaNome: unidade.infraestruturaNome,
                            infraestruturaId: unidade.infraestruturaId,
                            unidadeId: unidade.unidadeId,
                            cotaValor: this.formatMoney(cotaValor, 2),
                            valorUtilizado: this.verificaCotaValor ? this.formatMoney(cotaValorUtilizado, 2) : '0,00',
                            valorSaldo: this.verificaCotaValor ? this.formatMoney(cotaSaldoValor, 2) : this.formatMoney(cotaValor, 2),
                            cotaUnidade: this.formatMoney(cotaUnidade, 0),
                            quantidadeUtilizada: cotaQuantidadeUtilizada ?? 0,
                            quantidadeSaldo: (cotaUnidade - cotaQuantidadeUtilizada) ?? 0,
                            ano: this.model.cotaAno,
                        };

                        return result;
                    } else if (ano != null) {

                        let cotaQuantidadeUtilizada = 0;
                        let cotaValorUtilizado = 0;
                        let cotaSaldoValor = 0;

                        if(unidade.valorUtilizado){

                            cotaValorUtilizado = unidade.valorUtilizado
                            cotaValorUtilizado = parseFloat(cotaValorUtilizado.toString().replace(".", "").replace(",", "."));
                        }                       

                        const anoAtual = ano;

                        const calcularCota = (lista, chave, ano) =>
                            lista.filter(field => field.periodo.start.substr(6, 4) == ano)
                                .reduce((sum, element) => sum + this.formatSumMoney(element[chave]), 0);

                        const calcularQuantidade = (lista, chave, ano) =>
                            lista.filter(field => field.periodo.start.substr(6, 4) == ano)
                                .reduce((sum, element) => sum + (element[chave] ? Number(element[chave]) : 0), 0);


                        const calcularSaldoValor = (cota, valorUtilizado) => cota - valorUtilizado;

                        const formatarRetorno = (cotaValor, valorUtilizado, cotaSaldoValor, cotaUnidade, quantidadeUtilizada) => ({
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaNome: unidade.infraestruturaNome,
                            infraestruturaId: unidade.infraestruturaId,
                            unidadeId: unidade.unidadeId,
                            cotaValor: this.formatMoney(cotaValor, 2),
                            valorUtilizado: this.formatMoney(valorUtilizado, 2),
                            valorSaldo: this.formatMoney(cotaSaldoValor, 2),
                            cotaUnidade: this.formatMoney(cotaUnidade, 0),
                            quantidadeUtilizada: quantidadeUtilizada,
                            quantidadeSaldo: this.formatMoney(cotaUnidade - quantidadeUtilizada, 0),
                            ano: this.model.cotaAno,
                        });

                        const cotaValor = calcularCota(unidade.cotaSolicitante, 'cotaValor', anoAtual);
                        const cotaUnidade = calcularQuantidade(unidade.cotaSolicitante, 'cotaUnidade', anoAtual);


                        unidade.cotaSolicitante.forEach(field => {

                            if (field.cotaTipoId === this.enums.tipoCota.VALOR) {

                                cotaSaldoValor = calcularSaldoValor(cotaValor, cotaValorUtilizado);
                                this.verificaCotaValor = true;
                            } else if (field.cotaTipoId === this.enums.tipoCota.QUANTIDADE) {

                                cotaQuantidadeUtilizada += 1;
                                this.verificaCotaQuantidade = true;
                            } 
                        });

                        if (this.verificaCotaValor && this.verificaCotaQuantidade) {
                            return formatarRetorno(cotaValor, cotaValorUtilizado, cotaSaldoValor, cotaUnidade, cotaQuantidadeUtilizada);
                        }
                        if (this.verificaCotaValor && !this.verificaCotaQuantidade) {
                            return formatarRetorno(cotaValor, cotaValorUtilizado, cotaSaldoValor, 0, 0);
                        }
                        if (!this.verificaCotaValor && this.verificaCotaQuantidade) {
                            return formatarRetorno(cotaValor, 0, cotaValor, cotaUnidade, cotaQuantidadeUtilizada);
                        }

                        return formatarRetorno(cotaValor, 0, cotaValor, cotaUnidade, 0);

                    } else if (mes != null) {

                        let cotaValor = unidade.cotaSolicitante.filter(field => field.periodo.start.substr(3, 2) == mes).reduce((sum, element) =>
                            sum + this.formatSumMoney(element.cotaValor), 0);

                        let cotaUnidade =  unidade.cotaSolicitante.filter(field => field.periodo.start.substr(3, 2) == mes).reduce((sum, element) => {

                            if (element.cotaUnidade) {
                                sum = sum + Number(element.cotaUnidade);
                            }

                            return sum;
                        },0)


                        return {
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaNome: unidade.infraestruturaNome,
                            unidadeId: unidade.unidadeId,
                            infraestruturaId: unidade.infraestruturaId,
                            cotaValor:this.formatMoney(cotaValor, 2),
                            valorUtilizado: '0,00',
                            valorSaldo:this.formatMoney(cotaValor, 2),
                            cotaUnidade: this.formatMoney(cotaUnidade, 0),
                            quantidadeUtilizada: 0,
                            quantidadeSaldo: this.formatMoney(cotaUnidade, 0),
                            ano: this.model.cotaAno,
                        }

                    } else {

                        let cotaValor = unidade.cotaSolicitante.reduce((sum, element) =>
                            sum + this.formatSumMoney(element.cotaValor), 0);

                        let cotaUnidade =  unidade.cotaSolicitante.reduce((sum, element) => {

                            if (element.cotaUnidade) {
                                sum = sum + Number(element.cotaUnidade);
                            }

                            return sum;
                        },0)

                        return {
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaNome: unidade.infraestruturaNome,
                            unidadeId: unidade.unidadeId,
                            infraestruturaId: unidade.infraestruturaId,
                            cotaValor:this.formatMoney(cotaValor, 2),
                            valorUtilizado: '0,00',
                            valorSaldo:this.formatMoney(cotaValor, 2),
                            cotaUnidade: this.formatMoney(cotaUnidade, 0),
                            quantidadeUtilizada: 0,
                            quantidadeSaldo: this.formatMoney(cotaUnidade, 0),
                            ano: this.model.cotaAno,
                        }
                    }
                })

                return filterItems

            }

            return []
        },
    },
    created() {

        this.repositories = {
            cota: this.getConectaSusRepository('exameImagem.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        model:{
            cotaAno: null,
            cotaMes: null,
        },
        enums: {
            tipoCota,
        },
        filter: null,
        items: [],
        verificaCotaValor: false,
        verificaCotaQuantidade: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.cotaAno = moment().format("YYYY")
        },
        handleDestroy(item) {

            const Unidade = this.data.model.cotas.findIndex(a => a.unidadeId === item.unidadeId)
          
            if(this.data.model.cotas[Unidade].cotaSolicitante.length > 0){
               
                this.showValidationNotification('Prestador não pode ser excluído, pois existem cotas vinculadas.')

            }else {
                const objId = this.data.model.cotas.findIndex((obj => obj.unidadeId == item.unidadeId
                && obj.infraestruturaId == item.infraestruturaId));

                const destroy = async () => this.data.model.cotas.splice(objId, 1)

                this.showDeleteConfirmation('Deseja realmente excluir a cota o prestador?', destroy)
            }

            
        },
        handleClearFilter() {
            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        handleAnoCota() {

            this.setLoading()

            this.repositories.cota.getCotaPrestador({
                ano: this.model.cotaAno,
                mes: this.model.cotaMes
            })
                .then(response => {

                    this.data.model.cotas = response.data
                    this.data.model.cotas.push()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ formats, repository ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>